import { Close } from '@mui/icons-material'
import React from 'react'

export const searchFunction = (data, searchBy, searchValue) => {
  const result = []
  for (let i = 0; i < data?.length; i++) {
    const element = data[i]
    for (const field of searchBy) {
      const searchTerm = searchValue.toLowerCase()
      const elementValue = typeof element[field] === 'string' ? element[field].toLowerCase() : element[field]
      if (typeof elementValue === 'string') {
        if (elementValue.includes(searchTerm)) {
          result.push(element)
          break
        }
      } else {
        if (elementValue === searchTerm) {
          result.push(element)
          break
        }
      }
    }
  }
  return result
}

const SearchBar = ({ placeholder, value, onChange, clearSearch }) => {

  return (
    <div className="input-group" style={{width: '400px'}}>
      <input type="text" className="form-control"
        placeholder={placeholder || 'Search'}
        value={value}
        onChange={onChange} />
      {value ? <div className="input-group-append">
        <button
          className="btn btn-outline-secondary btn-sm btn-transparent"
          style={{
            position: 'absolute',
            right: '10px',
            top: '0px',
            zIndex: 10,
            border: 'none',
            background: 'transparent'
          }}
          onClick={clearSearch} type="button"><Close size="16" /></button>
      </div> : null}
    </div>

  )
}

export default SearchBar
